import { Button } from "@nimit9/signet-ui/components/button"
import { useEffect, useState } from "react"

const STAGES = [
  { label: "Reading your file", key: "format" },
  { label: "Unlocking document", key: "decrypt" },
  { label: "Reading transactions", key: "parse" },
  { label: "Checking for duplicates", key: "reconcile" },
] as const

interface StepParsingProps {
  fileName: string
  onCancel: () => void
}

export function StepParsing({ fileName, onCancel }: StepParsingProps) {
  const [stageIdx, setStageIdx] = useState(0)

  useEffect(() => {
    const id = setInterval(() => {
      setStageIdx((i) => Math.min(i + 1, STAGES.length - 1))
    }, 700)
    return () => clearInterval(id)
  }, [])

  return (
    <>
      <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-10 text-center">
        {/* Spinning ring */}
        <div className="relative size-[88px]">
          <style>{`
            @keyframes vault-ring-spin {
              from { transform: rotate(-90deg); }
              to   { transform: rotate(270deg); }
            }
          `}</style>
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            aria-label="Loading"
            style={
              {
                animation: "vault-ring-spin 1.2s linear infinite",
                transformOrigin: "44px 44px",
              } as React.CSSProperties
            }
          >
            <circle
              cx="44"
              cy="44"
              r="38"
              fill="none"
              stroke="var(--border-default)"
              strokeWidth="5"
            />
            <circle
              cx="44"
              cy="44"
              r="38"
              fill="none"
              stroke="var(--accent-amber)"
              strokeWidth="5"
              strokeLinecap="round"
              strokeDasharray="165 74"
            />
          </svg>
        </div>

        <div>
          <p className="text-[13px] font-medium text-text-primary">Reading {fileName}…</p>
          <p className="mt-1.5 font-mono text-[11px] tracking-wide text-text-muted">
            {STAGES[stageIdx].label}
          </p>
        </div>

        {/* Stage chips */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
          {STAGES.map((s, i) => (
            <span
              key={s.key}
              className="text-[11px]"
              style={{
                color:
                  i < stageIdx
                    ? "var(--accent-green)"
                    : i === stageIdx
                      ? "var(--accent-amber)"
                      : "var(--text-hint)",
                opacity: i > stageIdx ? 0.4 : 1,
              }}
            >
              {i < stageIdx ? "✓ " : i === stageIdx ? "● " : ""}
              {s.label}
            </span>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-between border-t border-border-subtle px-6 py-3.5">
        <Button variant="ghost" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="sm" disabled>
          Continue
        </Button>
      </div>
    </>
  )
}
